import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../core/Layout";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { listUsers } from "../actions/userActions";
import {
  listGenderEnums,
  listStatusEnums,
  createPatient,
  listTypeEnums,
} from "../actions/patientActions";
import { PATIENT_CREATE_RESET } from "../constants/patientDetailsConstants";
import { useNavigate } from "react-router-dom";
import AddAppVaccineModal from "../component/modal/addAppointment";


const AddPatientDetails = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [regDate, setRegDate] = useState(new Date());
  const [address, setAddress] = useState("Nairobi");
  const [phoneNo, setPhoneNo] = useState(null);
  const [aadharCard , setAadharCard] = useState("")
  const [abhaCard , setAbhaCard] = useState("")
  const [birthDate, setBirthDate] = useState(new Date());
  const [guardian, setGuardian] = useState("");
  const [relation, setRelation] = useState("");
  const [pincode ,setPincode] = useState("")
  const [gender, setGender] = useState("Male");
  const [showModal , setShowModal] = useState(false)
  const [selectedId , setSelectedId] = useState('')
  const [age , setAge] = useState('');
  const [patientId , setPatientId] = useState('');
  const [generatedId, setGeneratedId] = useState("");
  const [count2,setCount2] = useState(1);

  const navigate = useNavigate();
  const [image, setImage] = useState("");
  const [count,setCount] = useState(1);
  const [uploading, setUploading] = useState(false);

  const dispatch = useDispatch();

  const userList = useSelector((state) => state.userList);
  const { users } = userList;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const patientGender = useSelector((state) => state.patientGender);
  const { genders } = patientGender;

  const patientStatus = useSelector((state) => state.patientStatus);
  const { status } = patientStatus;

  const patientTypes = useSelector((state) => state.patientTypes);
  const { types } = patientTypes;

  const patientCreate = useSelector((state) => state.patientCreate);
  const { error, loading, success, patient } = patientCreate;

  useEffect(() => {
    if (userInfo) {
      dispatch(listUsers());
      dispatch(listTypeEnums());
      dispatch(listStatusEnums());
      dispatch(listGenderEnums());

      if (success) {
        dispatch({ type: PATIENT_CREATE_RESET });
        navigate("/list-patients");
      }
    } else {
      navigate("/signin");
    }
  }, [dispatch, userInfo, success]);

  const generatePatientID = () => {
  const timestamp = Date.now(); 
  return `P#${timestamp}`;
};

 const handleChange = (e) => {
    let value = e.target.value;
    if (!value.startsWith("P#")) {
      value = "P#" + value.replace(/^P#+/, "");
    }

    setPatientId(value);
  };

 
  const formContainerStyles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  
    padding: "15px",
    
    fontFamily: "Roboto sans-serif",
  };

  const formRowStyles = {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: "25px",
    fontFamily: "Roboto sans-serif",
  };

  const formGroupStyles = {
    width: "48%",
    marginBottom: "15px",
    fontFamily: "Roboto sans-serif",
  };

  const labelStyles = {
    fontWeight: "600",
    marginBottom: "12px",
    display: "block",
    color: "#333",
    fontSize: "14px",
    cursor: "pointer"
  };

 const age_DOB_Styles = {
    display: "flex",
  };

  

  const inputStyles = {
    width: "100%",
    padding: "12px",
    fontSize: "1rem",
    border: "1px solid #ccc",
    borderRadius: "6px",
    backgroundColor: "#fff",
    transition: "border-color 0.2s ease-in-out",
    fontFamily: "Roboto sans-serif",
  };

  const buttonStyles = {
    width: "100%",
    maxWidth: "200px",
    backgroundColor: "#007bff",
    border: "none",
    color: "white",
    padding: "12px 25px",
    fontSize: "1rem",
    borderRadius: "20px",
    cursor: "pointer",
    transition: "background-color 0.2s ease-in-out",
    marginBottom: "20px",
  };
  //const selectStyles = {
  const selectStyles = {
    ...inputStyles,
    padding: "5px",
    fontSize: "1rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
  const showLoading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      createPatient({
        firstName,
        lastName,
        pincode,
        regDate,
        address,
        aadharCard,
        abhaCard,
        phoneNo,
        birthDate,
        age,
        guardian,
        relation,
        gender,
        patientId
      })
    );
    
    
  };


  useEffect(()=>{
    if(success){
      setSelectedId(patient._id)
      setShowModal(true)
      }
    
  },[patient])

  useEffect(() => {
    setGeneratedId(generatePatientID());
  }, []);



  const patientDetailsForm = () => (
    <div style={formContainerStyles}>
      <form onSubmit={submitHandler}>
        <div className="form-row" style={formRowStyles}>
       

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>First Name</label>
            <input
              className="form-control py-4"
              type="text"
              style={inputStyles}
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Last Name</label>
            <input
              className="form-control py-4"
              type="text"
              style={inputStyles}
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>

       

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Registration Date</label>
            <DatePicker
              selected={regDate}
              onChange={(date) => setRegDate(date)}
              className="form-control"
              style={inputStyles}
            />
          </div>

          <div style={formGroupStyles}>
            <label style={labelStyles}>Address</label>
            <textarea
              className="form-control"
              style={inputStyles}
              placeholder="Write address"
              rows="3"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Phone No</label>
            <input
              type="number"
              style={inputStyles}
              placeholder="Phone Number"
              value={phoneNo}
              onChange={(e) => setPhoneNo(e.target.value)}
            />
          </div>

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Aadhar Card</label>
            <input
              type="text"
              style={inputStyles}
              placeholder="Aadhar Card"
              value={aadharCard}
              onChange={(e) => setAadharCard(e.target.value)}
            />
          </div> 

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Abha Card</label>
            <input
              type="text"
              style={inputStyles}
              placeholder="Abha Card"
              value={abhaCard}
              onChange={(e) => setAbhaCard(e.target.value)}
            />
          </div>
          <div className="form-group" style={formGroupStyles}>
            <div style={age_DOB_Styles}> 
              <label style={labelStyles} onClick={()=>setCount(1)}>Date of Birth /</label>
              <label style={labelStyles} onClick={()=>setCount(0)} >Age</label>
            </div> 
            {count?
            <DatePicker
              selected={birthDate}
              onChange={(date) => setBirthDate(date)}
              className="form-control"
              style={inputStyles}
            />
          :
          
            <input
              type="text"
              style={inputStyles}
              placeholder="Age"
              value={age}
              onChange={(e) => setAge(e.target.value)}
            />
        }
          </div>   
          
          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Patient Id</label>
            <input
              type="text"
              style={inputStyles}
              placeholder="Patient Id"
              value={patientId}
              onChange={handleChange}
            /> 
            
           {count2? (
              <p
                style={{ marginTop: "5px", color: "gray", cursor: "pointer" }}
                onClick={() => {
                setPatientId(generatePatientID());
                setCount2(0)
                 }}
              >
              {generatedId}
              </p>
           ):<p></p>}
          </div>

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Guardian</label>
            <input
              type="text"
              style={inputStyles}
              placeholder="Guardian"
              value={guardian}
              onChange={(e) => setGuardian(e.target.value)}
            />
          </div>

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Pincode</label>
            <input
              type="text"
              style={inputStyles}
              placeholder="pincode"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
            />
          </div>

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Relation</label>
            <input
              type="text"
              style={inputStyles}
              placeholder="Relation"
              value={relation}
              onChange={(e) => setRelation(e.target.value)}
            />
          </div>

          <div className="form-group" style={formGroupStyles}>
            <label style={labelStyles}>Gender</label>
            <select
              onChange={(e) => setGender(e.target.value)}
              className="form-control"
              style={selectStyles}
            >
              {genders &&
                genders.map((c, i) => (
                  <option key={i} value={c}>
                    {c}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <button type="submit" style={buttonStyles}>
          Save
        </button>
      </form>
    </div>
  );

  return (
    <Layout title="">
      <>
        <h2 style={{  fontFamily: "Roboto sans-serif" }}>
          Add Patient Details
        </h2>
        {showLoading()}
        {patientDetailsForm()}
        { showModal &&  (
		<AddAppVaccineModal
                show={showModal}
                onClose={() => setShowModal(false)}
                patientId={selectedId}
            />)}
      </>
    </Layout>
  );
};

export default AddPatientDetails;
